import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core'
import { Router } from '@angular/router'
import { ReportsGateway } from '../../../gatewasys/reports.gateway'
import { NetworkStateGateway } from '../../../../common/gateways/network-state-gateway'
import { ValidatedSelectOptionModel as State } from '../../../../validations/validated-dropdown.component'
import { MyClientsCriteria } from '../../../models/my-clients-criteria'
import { CurrentUserGateway } from '../../../../common/gateways/current-user-gateway'
import { CurrentUser } from '../../../../common/models/current-user'
import * as moment from 'moment'
import { ValidatedSelectOptionModel } from '../../../../validations/validated-dropdown.component'
import { OrgListContainerComponent } from './../org-list-container.component'
import { OrgSearchComponent } from './../org-search.component'
import { OrganizationDataGateway } from '../../../gatewasys/organization-data.gateway'
import { OrgBrowserOrgList } from '../../../models/org-browser-org-list'
import { OrgBrowserView } from '../../../models/org-browser-view'
import { MyClientsSavedSearch } from '../../../models/myclients-saved-search'
import { PortalGlobals } from '../../../../portalglobals'
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'NEJEclients-report',
    templateUrl: './clients-report.component.html',
    styleUrls: ['./clients-report.component.scss']
})
export class NEJEClientsReportComponent implements OnInit, OnDestroy {
    orgDropDownVisible: boolean
    orgTree: OrgBrowserOrgList[] = [] as OrgBrowserOrgList[]
    @ViewChild('orgListContainer')
    private orgListContainer: OrgListContainerComponent

    @ViewChild('orgSearch')
    private orgSearch: OrgSearchComponent
    myClientsCriteria: MyClientsCriteria
    states: State[] = [] as State[]
    error: boolean = false
    currentUser: CurrentUser
    rootOrgId: number
    errorMessage: string = ''
    isAdmin: boolean
    isSuperAdmin: boolean
    resetSearch: string
    carrierlst: ValidatedSelectOptionModel[]
    cuidlst: ValidatedSelectOptionModel[]
    planlst: ValidatedSelectOptionModel[]
    GroupNumberlst: ValidatedSelectOptionModel[]
    agentlst: ValidatedSelectOptionModel[]
    orgID: number = 0
    state: string = '0'
    carrierId: string = '0'
    cuid: string = '0'
    icorgId: number = 0
    selectedOrgValue: string | null = ''
    selectedOrgsVisible: boolean = false
    selectedSearch: MyClientsSavedSearch
    newSearchOption: MyClientsSavedSearch
    savedSearches: MyClientsSavedSearch[]
    orglistRefresh: string
    IsMedicareIDClick: boolean = false
    IsClearClick: boolean = false
    startdate: string
    endate: string

    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    baseTitle: string
    
    constructor(
        private routers: Router,
        private orgGateway: OrganizationDataGateway,
        private reportsGateway: ReportsGateway,
        private currentUserGateway: CurrentUserGateway,
        private _stateGateway: NetworkStateGateway,
        public _global: PortalGlobals,
        private titleService: Title
    ) {}

    ngOnInit() {
        // Set unique title
        this.baseTitle = this.titleService.getTitle();
        this.titleService.setTitle( this.baseTitle + ' - My Clients')

        this.myClientsCriteria = {} as MyClientsCriteria
        this.myClientsCriteria = this.reportsGateway.myClientsCriteria
        this.myClientsCriteria.ReportCategory = ''

        if (
            this.myClientsCriteria.ApplicationStartDate === '' ||
            this.myClientsCriteria.ApplicationStartDate === undefined ||
            this.myClientsCriteria.ApplicationStartDate === null
        ) {
            this.myClientsCriteria.ApplicationStartDate = moment('10/01/2005').format('MM/DD/YYYY')
            this.myClientsCriteria.ApplicationEndDate = moment().format('MM/DD/YYYY')
        }
        // this.getstate()
        //this.createNewSearch();
        //this.loadCurrentUser();
        if (JSON.parse(localStorage.getItem('clientCriteria')!) === undefined || JSON.parse(localStorage.getItem('clientCriteria')!) === null) {
            this.createNewSearch()
            this.loadCurrentUser()
            this.myClientsCriteria.CUID = '0'
            this.myClientsCriteria.GroupName = '0'
            this.myClientsCriteria.GroupNumber = '0'
            this.myClientsCriteria.AgentID = ''
        } else {
            this.myClientsCriteria = JSON.parse(localStorage.getItem('clientCriteria')!)
            this.loadCurrentUserOnRefresh()

            this.startdate = this.myClientsCriteria.ApplicationStartDate
            this.endate = this.myClientsCriteria.ApplicationEndDate

            this.myClientsCriteria.ApplicationStartDate = moment(this.startdate).format('M/D/YYYY')
            this.myClientsCriteria.ApplicationEndDate = moment(this.endate).format('M/D/YYYY')

            this.setOrgValueOnRefresh(this.myClientsCriteria.ReportType)
        }
        this.IsMedicareIDClick = false
    }

    loadCurrentUserOnRefresh(): void {
        this.currentUser = JSON.parse(localStorage.getItem('reportuser')!)

        if (this.currentUser != null && this.currentUser.orgId != null) {
            this.rootOrgId = parseInt(this.currentUser.orgId, 10)
            this.icorgId = parseInt(this.currentUser.insuranceCompanyId)
            this.isAdmin = this.currentUser.IsAdmin
            this.isSuperAdmin = this.currentUser.IsSuperAdminAdmin
            this.myClientsCriteria.InsuranceCompany = this.currentUser.insuranceCompanyName

            //if (this.isAdmin === false) {
            if (
                this.currentUser.roleCode === 'Organization Manager' ||
                this.currentUser.roleCode === 'Organization Admin' ||
                this.currentUser.roleCode === 'Admin / Agent' ||
                this.currentUser.roleCode === 'Auditor' ||
                this.currentUser.isGroupAdmin ||
                this.currentUser.roleCode === 'Call Center Admin'
            ) {
                this.isAdmin = true
                this.isSuperAdmin = true
            }
            // }
            if (this.currentUser.roleCode === 'Marketing Agent') {
                this.isAdmin = false
                this.isSuperAdmin = false
                this.myClientsCriteria.AgentID = this.currentUser.userProfileName
            }

            if (!this.isSuperAdmin) {
                this.myClientsCriteria.AgentID = this.currentUser.userProfileName
            }

            if (this.isAdmin || this.isSuperAdmin) {
                this.isAdmin = true
            }
            this.myClientsCriteria.LoginProfileID = this.currentUser.userProfileId.toString()
            this.myClientsCriteria.OrgID = +this.currentUser.orgId
            if (
                this.myClientsCriteria.ApplicationStartDate === '' ||
                this.myClientsCriteria.ApplicationStartDate === undefined ||
                this.myClientsCriteria.ApplicationStartDate === null
            ) {
                this.myClientsCriteria.ApplicationStartDate = '10/01/2005'
                this.myClientsCriteria.ApplicationEndDate = moment().format('MM/DD/YYYY')
            }
            // this.getCarrierList(this.icorgId, 'Carrier')
            this.getstate(this.icorgId, 'State')
            this.getCUIDList(this.rootOrgId, 'CUID')
            this.getPlanTypeList(this.rootOrgId, 'Group Name')
            this.getGroupNumberList(this.rootOrgId, 'Group Number')
            // this.getAgentList(this.icorgId, this.state)
            this.myClientsCriteria.InsuranceCompany = this.currentUser.insuranceCompanyName
        } else {
            console.log('current user is undefined')
        }
    }

    setOrgValueOnRefresh(value: any): void {
        this.selectedOrgValue = value

        if (this.selectedOrgValue === 'ALL' || this.selectedOrgValue === 'ALLACTIVE' || this.selectedOrgValue === 'CUSTOM') {
            this.resetSearch = value
            this.selectedOrgsVisible = true
            const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()
            //  this.routers.navigateByUrl('/' + insCo + '/reports/my-clients')
        }

        switch (this.selectedOrgValue) {
            case 'ALLACTIVE':
                this.myClientsCriteria.ReportType = this.selectedOrgValue
                if (this.currentUser !== undefined && this.currentUser !== null) {
                    this.createNewSearch()
                    this.myClientsCriteria.ReportCategory = 'ALL'
                    this.selectedSearch.selectedOrgs = JSON.parse(localStorage.getItem('OrgData')!)
                    this.getSelectedOrgs()
                    this.hideOrgDropDown()
                }
                break
            case 'ALL':
                this.myClientsCriteria.ReportType = this.selectedOrgValue
                if (this.currentUser !== undefined && this.currentUser !== null) {
                    this.createNewSearch()
                    this.myClientsCriteria.ReportCategory = 'ALL'
                    this.selectedSearch.selectedOrgs = JSON.parse(localStorage.getItem('OrgData')!)
                    this.getSelectedOrgs()
                    this.hideOrgDropDown()
                }
                break
            case 'CUSTOM':
                this.myClientsCriteria.ReportType = this.selectedOrgValue
                this.myClientsCriteria.ReportCategory = 'ALL'
                this.myClientsCriteria.OrgList = ''
                this.showOrgDropDown()
                this.createNewSearch()
                this.selectedSearch.selectedOrgs = JSON.parse(localStorage.getItem('OrgData')!)
                this.getSelectedOrgs()
                break
            default:
                this.selectedOrgsVisible = false
                break
        }
    }


    ngOnDestroy() {
        this.titleService.setTitle(this.baseTitle)

        if (this.IsMedicareIDClick === false) localStorage.removeItem('clientCriteria')

        localStorage.removeItem('countCriteria')
        //this.myClientsCriteria = {} as MyClientsCriteria
        //this.myClientsCriteria.AgentID = ''
        //this.myClientsCriteria.UserType = ''
        //this.reportsGateway.myClientsCriteria = this.myClientsCriteria
    }

    searchByMedicareID(): void {
        this.IsMedicareIDClick = true

        localStorage.setItem('clientCriteria', JSON.stringify(this.myClientsCriteria))

        //localStorage.removeItem("OrgData")
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.routers.navigateByUrl('/' + insCo + '/reports/neje-medicareid-search')
    }

    onInfoChange(fieldName: string, fieldValue: string): void {
        this.myClientsCriteria[fieldName] = fieldValue
    }
    getstate(orgID: number, filterCriteria: string) {
        this.reportsGateway.getCarrierList(orgID, filterCriteria).subscribe((model: ValidatedSelectOptionModel[]) => {
            model.unshift({ value: '0', text: 'All' })
            this.states = model
            if (
                this.myClientsCriteria.State === undefined ||
                this.myClientsCriteria.State === '' ||
                this.myClientsCriteria.State === '0' ||
                this.myClientsCriteria.State === null
            ) {
                this.myClientsCriteria.State = '0'
            }
        })
        //this._stateGateway.getAllStates().subscribe(
        //    (states: State[]) => {
        //        states.unshift({ value: '0', text: '-- All --', })
        //        this.states = states
        //        if (this.myClientsCriteria.State === undefined || this.myClientsCriteria.State === '' || this.myClientsCriteria.State === '0' || this.myClientsCriteria.State === null) {
        //            this.myClientsCriteria.State = '0'
        //        }
        //    }
        //)
    }
    getCarrierList(orgID: number, filterCriteria: string) {
        this.reportsGateway.getCarrierList(orgID, filterCriteria).subscribe((model: ValidatedSelectOptionModel[]) => {
            model.unshift({ value: '0', text: 'ANY' })
            this.carrierlst = model
            if (
                this.myClientsCriteria.Carrier === undefined ||
                this.myClientsCriteria.Carrier === '' ||
                this.myClientsCriteria.Carrier === '0' ||
                this.myClientsCriteria.Carrier === null
            ) {
                this.myClientsCriteria.Carrier = '0'
            }
        })
    }
    getCUIDList(orgID: number, filterCriteria: string) {
        this.reportsGateway.getCarrierList(orgID, filterCriteria).subscribe((model: ValidatedSelectOptionModel[]) => {
            model.unshift({ value: '0', text: 'ANY' })
            this.cuidlst = model
            if (
                this.myClientsCriteria.CUID === undefined ||
                this.myClientsCriteria.CUID === '' ||
                this.myClientsCriteria.CUID === '0' ||
                this.myClientsCriteria.CUID === null
            ) {
                this.myClientsCriteria.CUID = '0'
            }
        })
        //this.reportsGateway.getCUIDList(orgID, state,carrierId)
        //    .subscribe((model: ValidatedSelectOptionModel[]) => {
        //        this.cuidlst = model
        //    })
    }
    getPlanTypeList(orgID: number, filterCriteria: string) {
        this.reportsGateway.getCarrierList(orgID, filterCriteria).subscribe((model: ValidatedSelectOptionModel[]) => {
            model.unshift({ value: '0', text: 'ANY' })
            this.planlst = model
            if (
                this.myClientsCriteria.GroupName === undefined ||
                this.myClientsCriteria.GroupName === '' ||
                this.myClientsCriteria.Plans === '0' ||
                this.myClientsCriteria.GroupName === null
            ) {
                this.myClientsCriteria.GroupName = '0'
            }
        })
        //this.reportsGateway.getPlanTypeList(orgID, state, carrierId, cuid)
        //    .subscribe((model: ValidatedSelectOptionModel[]) => {
        //        this.planlst = model
        //    })
    }
    getGroupNumberList(orgID: number, filterCriteria: string) {
        this.reportsGateway.getCarrierList(orgID, filterCriteria).subscribe((model: ValidatedSelectOptionModel[]) => {
            model.unshift({ value: '0', text: 'ANY' })
            this.GroupNumberlst = model
            if (
                this.myClientsCriteria.GroupNumber === undefined ||
                this.myClientsCriteria.GroupNumber === '' ||
                this.myClientsCriteria.GroupNumber === '0' ||
                this.myClientsCriteria.GroupNumber === null
            ) {
                this.myClientsCriteria.GroupNumber = '0'
            }
        })
    }

    getAgentList(orgID: number, filterCriteria: string) {
        this.reportsGateway.getCarrierList(orgID, filterCriteria).subscribe((model: ValidatedSelectOptionModel[]) => {
            this.agentlst = model
            if (
                this.myClientsCriteria.AgentID === undefined ||
                this.myClientsCriteria.AgentID === '' ||
                this.myClientsCriteria.AgentID === '0' ||
                this.myClientsCriteria.AgentID === null
            ) {
                this.myClientsCriteria.AgentID = '0'
            }
        })
        //this.reportsGateway.getAgentList(orgID, state, carrierId, cuid)
        //    .subscribe((model: ValidatedSelectOptionModel[]) => {
        //        this.agentlst = model
        //    })
    }

    showHideOrgDropDown(): void {
        if (this.orgDropDownVisible === true) {
            this.hideOrgDropDown()
        } else {
            this.showOrgDropDown()
        }
    }

    loadCurrentUser(): void {
        this.currentUserGateway.getCurrentUser().subscribe(
            (user: CurrentUser) => {
                this.currentUser = user
                localStorage.setItem('reportuser', JSON.stringify(this.currentUser))
                this._global.currentUser = user
                if (this.currentUser != null && this.currentUser.orgId != null) {
                    this.rootOrgId = parseInt(this.currentUser.orgId, 10)
                    this.icorgId = parseInt(this.currentUser.insuranceCompanyId)
                    this.isAdmin = this.currentUser.IsAdmin
                    this.isSuperAdmin = this.currentUser.IsSuperAdminAdmin
                    this.myClientsCriteria.InsuranceCompany = this.currentUser.insuranceCompanyName

                    //if (this.isAdmin === false) {
                    if (
                        this.currentUser.roleCode === 'Organization Manager' ||
                        this.currentUser.roleCode === 'Organization Admin' ||
                        this.currentUser.roleCode === 'Admin / Agent' ||
                        this.currentUser.roleCode === 'Auditor' ||
                        this.currentUser.isGroupAdmin ||
                        this.currentUser.roleCode === 'Call Center Admin'
                    ) {
                        this.isAdmin = true
                        this.isSuperAdmin = true
                    }
                    // }
                    if (this.currentUser.roleCode === 'Marketing Agent') {
                        this.isAdmin = false
                        this.isSuperAdmin = false
                        this.myClientsCriteria.AgentID = this.currentUser.userProfileName
                    }

                    if (!this.isSuperAdmin) {
                        this.myClientsCriteria.AgentID = this.currentUser.userProfileName
                    }

                    if (this.isAdmin || this.isSuperAdmin) {
                        this.isAdmin = true
                    }
                    this.myClientsCriteria.LoginProfileID = this.currentUser.userProfileId.toString()
                    this.myClientsCriteria.OrgID = +this.currentUser.orgId
                    if (
                        this.myClientsCriteria.ApplicationStartDate === '' ||
                        this.myClientsCriteria.ApplicationStartDate === undefined ||
                        this.myClientsCriteria.ApplicationStartDate === null
                    ) {
                        this.myClientsCriteria.ApplicationStartDate = '10/01/2005'
                        this.myClientsCriteria.ApplicationEndDate = moment().format('MM/DD/YYYY')
                    }
                    // this.getCarrierList(this.icorgId, 'Carrier')
                    this.getstate(this.icorgId, 'State')
                    this.getCUIDList(this.rootOrgId, 'CUID')
                    this.getPlanTypeList(this.rootOrgId, 'Group Name')
                    this.getGroupNumberList(this.rootOrgId, 'Group Number')
                    // this.getAgentList(this.icorgId, this.state)
                    this.myClientsCriteria.InsuranceCompany = this.currentUser.insuranceCompanyName
                } else {
                    console.log('current user is undefined')
                }
            },
            (error) => {
                console.log(error)
            }
        )
    }
    onGetEnrollments() {
        this.errorMessage = ''
        if (
            this.myClientsCriteria === undefined ||
            this.myClientsCriteria.ApplicationEndDate === undefined ||
            this.myClientsCriteria.ApplicationStartDate === undefined ||
            this.myClientsCriteria.ApplicationStartDate === null ||
            this.myClientsCriteria.ApplicationEndDate === null
        ) {
            this.error = true
            this.clearForm()
            this.errorMessage = 'Application Start/End date is required.'
            this.focusableEleTop.nativeElement.focus()

            return
        }

        if (
            (this.myClientsCriteria.AgentID === undefined ||
                this.myClientsCriteria.AgentID === null ||
                this.myClientsCriteria.AgentID.trim() === '') &&
            (this.selectedSearch === undefined ||
                this.selectedSearch === null ||
                this.selectedSearch.selectedOrgs === undefined ||
                this.selectedSearch.selectedOrgs === null ||
                this.selectedSearch.selectedOrgs.length <= 0) &&
            this.currentUser.roleCode !== 'Marketing Agent'
        ) {
            this.error = true
            this.clearForm()
            this.errorMessage = 'Organizations are required'
            this.focusableEleTop.nativeElement.focus()

            return
        }

        this.error = false
        this.errorMessage = ''

        if (this.selectedSearch !== undefined) {
            if (this.selectedSearch.selectedOrgs !== null && this.selectedSearch.selectedOrgs.length > 0) {
                this.selectedSearch.selectedOrgs = JSON.parse(localStorage.getItem('OrgData')!)
                this.orglistRefresh = this.selectedSearch.selectedOrgs.map((o) => o.orgId.toString()).join()

                this.myClientsCriteria.OrgList = this.selectedSearch.selectedOrgs.map((o) => o.orgId.toString()).join()
                if (this.orglistRefresh !== this.myClientsCriteria.OrgList) {
                    localStorage.removeItem('OrgData')
                }
            }
        }

        this.myClientsCriteria.IsClearReport = false

        this.reportsGateway.myClientsCriteria = this.myClientsCriteria
        this.myClientsCriteria.InsuranceCompany = this.currentUser.insuranceCompanyName

        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        // this.myClientsCriteria.OrgList = this.selectedSearch.selectedOrgs.map(o => o.orgId.toString()).join();
        this.routers.navigateByUrl('/' + insCo + '/reports/neje-my-clients').then((value) => {
            if (value) this.routers.navigateByUrl('/' + insCo + '/reports/neje-my-clients/counts')
            else this.routers.navigateByUrl('/' + insCo + '/reports/neje-my-clients/counts')
        })
    }
    clearForm(): void {
        //this.myClientsCriteria = {} as MyClientsCriteria
        //this.createNewSearch()
        this.myClientsCriteria.CUID = '0'
        this.myClientsCriteria.GroupName = '0'
        this.myClientsCriteria.OrgList = ''
        this.myClientsCriteria.ReportType = ''
        this.selectedOrgValue = ''

        if (this.currentUser.roleCode !== 'Marketing Agent') this.myClientsCriteria.AgentID = ''

        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        this.createNewSearch()
        this.hideOrgDropDown()
        this.selectedOrgsVisible = false
        this.selectedOrgValue = null

        this.myClientsCriteria.IsClearReport = true

        //Remove from cache
        // localStorage.removeItem('clientCriteria')
        this.reportsGateway.myClientsCriteria = this.myClientsCriteria

        this.routers.navigateByUrl('/' + insCo + '/reports/neje-my-clients')
    }
    createNewSearch(): void {
        this.selectedSearch = {
            searchId: -1,
            searchName: 'New Search',
            isAll: false,
            selectedOrgs: [] as OrgBrowserView[]
        } as MyClientsSavedSearch
    }
    hideOrgDropDown(): void {
        this.orgDropDownVisible = false
    }
    showOrgDropDown(): void {
        this.orgDropDownVisible = true
        setTimeout(() => {
            if (this.orgListContainer !== undefined && this.orgListContainer !== null) {
                this.orgListContainer.initOrgTree(parseInt(this.currentUser.orgId, 10))
            }
        }, 1000)
        //this.createNewSearch();
    }

    setOrgValue(value: any): void {
        localStorage.removeItem('clientCriteria')

        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.selectedOrgValue = value
        if (this.selectedOrgValue === 'ALL' || this.selectedOrgValue === 'ALLACTIVE' || this.selectedOrgValue === 'CUSTOM') {
            this.resetSearch = value
            this.selectedOrgsVisible = true
            this.routers.navigateByUrl('/' + insCo + '/reports/neje-my-clients')
        }

        switch (this.selectedOrgValue) {
            case 'ALLACTIVE':
                if (this.currentUser !== undefined && this.currentUser !== null) {
                    this.myClientsCriteria.ReportType = this.selectedOrgValue
                    this.createNewSearch()
                    this.refreshOrgTree(this.rootOrgId, true, true)
                    this.myClientsCriteria.ReportCategory = 'ALL'
                    this.hideOrgDropDown()
                }
                break
            case 'ALL':
                if (this.currentUser !== undefined && this.currentUser !== null) {
                    this.myClientsCriteria.ReportType = this.selectedOrgValue
                    this.createNewSearch()
                    this.refreshOrgTree(this.rootOrgId, true, false)
                    this.myClientsCriteria.ReportCategory = 'ALL'
                    this.hideOrgDropDown()
                }
                break
            case 'CUSTOM':
                this.myClientsCriteria.ReportType = this.selectedOrgValue
                this.createNewSearch()
                this.myClientsCriteria.ReportCategory = 'ALL'
                this.myClientsCriteria.OrgList = ''
                this.showOrgDropDown()
                break
            default:
                this.selectedOrgsVisible = false
                break
        }
    }

    reportCategoryText(): string {
        if (this.selectedOrgValue === 'ALL') {
            return 'All Organizations'
        } else if (this.selectedOrgValue === 'ALLACTIVE') {
            return 'All Active Organizations'
        } else if (this.selectedOrgValue === 'CUSTOM') {
            return 'Selected Organizations'
        } else {
            return 'None'
        }
    }
    createSavedSearches(): void {
        this.savedSearches = [{ searchId: -1, searchName: 'All Organizations' } as MyClientsSavedSearch] as MyClientsSavedSearch[]
    }
    onOrgAdd(org: OrgBrowserView): void {
        this.addOrg(org)
    }
    onAddOrgList(orgId: number): void {
        this.orgGateway.getOrganization(orgId).subscribe((currentOrg) => {
            this.orgGateway.getOrganizationsForParent(orgId).subscribe((childOrgs) => {
                const orgList: OrgBrowserOrgList = {
                    currentOrganization: currentOrg,
                    organizations: childOrgs,
                    selectedOrganization: undefined
                } as OrgBrowserOrgList
                if (this.orgTree === undefined || this.orgTree === null) {
                    this.orgTree = [] as OrgBrowserOrgList[]
                }
                this.orgTree = this.orgTree.concat([orgList])
            })
        })
    }
    addOrg(org: OrgBrowserView): void {
        org.includeDownline = true
        this.selectedSearch.selectedOrgs = this.selectedSearch.selectedOrgs.concat([org])

        localStorage.setItem('OrgData', JSON.stringify(this.selectedSearch.selectedOrgs))
    }

    onSearchResultsChanged(orgs: OrgBrowserView[]): void {
        if (
            this.selectedSearch === undefined ||
            this.selectedSearch === null ||
            this.selectedSearch.selectedOrgs === undefined ||
            this.selectedSearch.selectedOrgs === null
        ) {
            return
        }
        this.selectedSearch.selectedOrgs.forEach((o) => {
            orgs.forEach((o2) => {
                if (o.orgId === o2.orgId) {
                    o2.selected = true
                }
            })
        })
    }

    toggleDownline(org: OrgBrowserView): void {
        org.includeDownline = !org.includeDownline
    }

    removeOrg(org: OrgBrowserView): void {
        org.includeDownline = false
        const pos = this.selectedSearch.selectedOrgs.indexOf(org, 0)
        this.selectedSearch.selectedOrgs.splice(pos, 1)

        localStorage.setItem('OrgData', JSON.stringify(this.selectedSearch.selectedOrgs))

        this.orgListContainer.orgUnSelect(org)
        this.orgSearch.orgUnSelect(org)
    }
    refreshOrgTree(orgId: number, selectAll: boolean = false, activeOnly: boolean = false): void {
        this.orgGateway.getOrganization(orgId).subscribe((currentOrg) => {
            this.orgGateway.getOrganizationsForParent(orgId).subscribe((childOrgs) => {
                if (activeOnly === false) {
                    childOrgs = [currentOrg].concat(childOrgs)
                }
                if (activeOnly === true) {
                    childOrgs = childOrgs.filter((o) => o.isActive === true)
                    if (currentOrg.isActive === true) childOrgs = [currentOrg].concat(childOrgs)
                }
                const orgList: OrgBrowserOrgList = {
                    currentOrganization: currentOrg,
                    organizations: childOrgs,
                    selectedOrganization: undefined
                } as OrgBrowserOrgList

                if (selectAll === true) {
                    orgList.organizations.forEach((o) => {
                        o.selected = true
                        this.onOrgAdd(o)
                    })
                }
            })
        })
    }
    getSelectedOrgs(): OrgBrowserView[] {
        if (
            this.selectedSearch === undefined ||
            this.selectedSearch === null ||
            this.selectedSearch.selectedOrgs === undefined ||
            this.selectedSearch.selectedOrgs === null
        ) {
            return [] as OrgBrowserView[]
        }
        const activeOrgs: OrgBrowserView[] = this.selectedSearch.selectedOrgs
            .filter((o) => o.isActive === true)
            .sort((a: OrgBrowserView, b: OrgBrowserView) => {
                if (a.orgName > b.orgName) {
                    return 1
                } else if (a.orgName < b.orgName) {
                    return -1
                } else {
                    return 0
                }
            })

        const inactiveOrgs: OrgBrowserView[] = this.selectedSearch.selectedOrgs
            .filter((o) => o.isActive === false)
            .sort((a: OrgBrowserView, b: OrgBrowserView) => {
                if (a.orgName > b.orgName) {
                    return 1
                } else if (a.orgName < b.orgName) {
                    return -1
                } else {
                    return 0
                }
            })
        return activeOrgs.concat(inactiveOrgs)
    }
}
